import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faBuildingColumns } from '@fortawesome/free-solid-svg-icons/faBuildingColumns';
import { faBus } from '@fortawesome/free-solid-svg-icons/faBus';
import { faCalculator } from '@fortawesome/free-solid-svg-icons/faCalculator';
import { faCar } from '@fortawesome/free-solid-svg-icons/faCar';
import { faCarSide } from '@fortawesome/free-solid-svg-icons/faCarSide';
import { faChargingStation } from '@fortawesome/free-solid-svg-icons/faChargingStation';
import { faChartSimple } from '@fortawesome/free-solid-svg-icons/faChartSimple';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons/faCircleXmark';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faGasPump } from '@fortawesome/free-solid-svg-icons/faGasPump';
import { faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons/faHandHoldingDollar';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons/faMicrophone';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons/faNewspaper';
import { faPencil } from '@fortawesome/free-solid-svg-icons/faPencil';
import { faPerson } from '@fortawesome/free-solid-svg-icons/faPerson';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faScaleBalanced } from '@fortawesome/free-solid-svg-icons/faScaleBalanced';
import { faShareFromSquare } from '@fortawesome/free-solid-svg-icons/faShareFromSquare';
import { faSitemap } from '@fortawesome/free-solid-svg-icons/faSitemap';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faTable } from '@fortawesome/free-solid-svg-icons/faTable';
import { faTableList } from '@fortawesome/free-solid-svg-icons/faTableList';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons/faMapLocationDot';
import { faMobileScreen } from '@fortawesome/free-solid-svg-icons/faMobileScreen';

//before removing any icons, search to ensure they are not being used on multiple pages
library.add(
  faAngleUp,
  faBuildingColumns,
  faBus,
  faCalculator,
  faCar,
  faCarSide,
  faChargingStation,
  faChartSimple,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faDollarSign,
  faDownload,
  faGasPump,
  faHandHoldingDollar,
  faMagnifyingGlass,
  faMapLocationDot,
  faMicrophone,
  faMinus,
  faMinusCircle,
  faMobileScreen,
  faNewspaper,
  faPerson,
  faPlus,
  faPlusCircle,
  faPrint,
  faScaleBalanced,
  faShareFromSquare,
  faSitemap,
  faSpinner,
  faTable,
  faTableList,
  faTriangleExclamation,
  faTruck,
  faUsers,
  faWrench,
  faXmark,

  // The following icons are only used in the afdc-legacy PHP applications, so
  // their usage may not be obvious within sponge, but we're include them here,
  // in the site-wide icons, since the PHP apps don't have an easy way to
  // import FontAwsome (or other modern ES6 javascript).
  faCircleXmark,
  faPencil,
  faQuestionCircle,
);

dom.watch();
